export default {
    MODAL: {
        OPEN: 'open',
        CLOSED: 'closed'
    },
    MENU: {
        OPEN: 'open',
        CLOSED: 'closed'
    },
    ITEM_LAYOUT: {
        GRID: 'layout-grid',
        LIST: 'layout-list'
    }
};
